const SearchValue = (state='Spider',action)=>{
    if(action.type==='SEARCH'){
        return action.payload
    }
    return state
}

export default SearchValue